import { Outlet } from 'react-router-dom';

/** Layout para páginas no autenticadas (login, reset password). */
export function AuthLayout() {
  return (
    <div
      className="min-h-dvh relative flex items-center justify-center p-6 overflow-hidden"
      style={{
        background:
          'radial-gradient(120% 90% at 80% 0%, #2A1A8A 0%, #0E1480 30%, #0A0E1F 70%)',
      }}
    >
      {/* Glow secundario abajo-izquierda */}
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'radial-gradient(60% 80% at 20% 100%, rgba(74,86,255,.25), transparent 60%)',
        }}
      />

      <div className="relative z-10 w-full max-w-[540px]">
        <Outlet />
      </div>

      <div
        aria-hidden
        className="absolute bottom-6 left-0 right-0 text-center font-mono text-[10px] uppercase font-medium"
        style={{ color: '#A8AEFF', letterSpacing: '0.14em' }}
      >
        Icaria Atelier × Internal
      </div>
    </div>
  );
}
